module.exports = __webpack_public_path__ + "assets/PerpBisectorDetailed.6aaa85304d05eddbfcdcc61cc7ef9019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/PerpBisectorDetailed.png
// module id = 551
// module chunks = 0